/* eslint-disable */
import React from "react";
import { TextField, IconButton, Tooltip } from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { FormattedMessage } from "react-intl";
import { PasswordFieldProps } from "./types";
import { usePasswordField } from "./usePasswordField";
import { useStyles } from "./styles";
import cn from "classnames";

export const PasswordField: React.ComponentType<PasswordFieldProps> = (props) => {
  const {
    customErrorState,
    isHaveValidateText = true,
    isHaveTooltip = true,
    customLabel,
    inputProps = {},
    onPasswordInvalid,
    onPasswordValid,
    newPassword,
    confirmPassword,
    customHelperText,
    ...otherProps
  } = props;
  const { mode = "password", className, disabled } = otherProps;
  const classes = useStyles();
  const [{ type, valid, showError, errors, label }, { onChange, onFocus, toggleShowType }] = usePasswordField(props);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const textField = () => (
    <TextField
      id={mode}
      key={mode}
      error={customErrorState !== undefined ? customErrorState : !valid && showError}
      {...otherProps}
      type={type}
      onBlur={onFocus}
      onChange={onChange}
      label={customLabel ? <FormattedMessage {...customLabel} /> : <FormattedMessage {...label} />}
      helperText={
        customHelperText || customErrorState ? (
          customHelperText
        ) : isHaveValidateText && showError && !valid ? (
          <FormattedMessage {...errors[0]} />
        ) : (
          undefined
        )
      }
      InputProps={{
        endAdornment: (
          <IconButton size="small" onClick={!disabled ? toggleShowType : () => {}} onMouseDown={handleMouseDownPassword}>
            {type === "password" || disabled ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
          </IconButton>
        ),
        ...inputProps,
      }}
      FormHelperTextProps={{ classes: { root: classes.helperText } }}
      classes={{ root: cn(classes.textField, className) }}
    ></TextField>
  );

  return isHaveTooltip ? (
    <Tooltip
      placement={"right"}
      title="The password must contain at least eight characters, lowercase and uppercase letters, numbers, and special characters"
    >
      {textField()}
    </Tooltip>
  ) : (
    textField()
  );
};
